// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
export const NotificationType = {
    NOTIFICATION_TYPE_PRODUCT_UPSELL: 'NOTIFICATION_TYPE_PRODUCT_UPSELL',
    NOTIFICATION_TYPE_PRODUCT_ADOPTION: 'NOTIFICATION_TYPE_PRODUCT_ADOPTION',
    NOTIFICATION_TYPE_CUSTOMER_ACQUISITION: 'NOTIFICATION_TYPE_CUSTOMER_ACQUISITION',
};
export const NotificationTypeValue = {
    NOTIFICATION_TYPE_PRODUCT_UPSELL: 0,
    NOTIFICATION_TYPE_PRODUCT_ADOPTION: 1,
    NOTIFICATION_TYPE_CUSTOMER_ACQUISITION: 2,
};
export const EventType = {
    EMPTY: 'EMPTY',
    PROCESSED: 'PROCESSED',
    DELIVERED: 'DELIVERED',
    OPENED: 'OPENED',
    CLICKED: 'CLICKED',
    BOUNCED: 'BOUNCED',
    DEFERRED: 'DEFERRED',
    DROPPED: 'DROPPED',
    SPAMREPORT: 'SPAMREPORT',
    UNSUBSCRIBED: 'UNSUBSCRIBED',
    RESUBSCRIBED: 'RESUBSCRIBED',
};
export const EventTypeValue = {
    EMPTY: 0,
    PROCESSED: 1,
    DELIVERED: 2,
    OPENED: 3,
    CLICKED: 4,
    BOUNCED: 5,
    DEFERRED: 6,
    DROPPED: 7,
    SPAMREPORT: 8,
    UNSUBSCRIBED: 9,
    RESUBSCRIBED: 10,
};
export const ContentContentType = {
    TEXT_PLAIN: 'TEXT_PLAIN',
    TEXT_HTML: 'TEXT_HTML',
};
export const ContentContentTypeValue = {
    TEXT_PLAIN: 0,
    TEXT_HTML: 1,
};
export const Visibility = {
    VISIBILITY_INVALID: 'VISIBILITY_INVALID',
    VISIBILITY_PRIVATE: 'VISIBILITY_PRIVATE',
    VISIBILITY_INTERNAL: 'VISIBILITY_INTERNAL',
    VISIBILITY_PUBLIC: 'VISIBILITY_PUBLIC',
    VISIBILITY_REDACTED: 'VISIBILITY_REDACTED',
};
export const VisibilityValue = {
    VISIBILITY_INVALID: 0,
    VISIBILITY_PRIVATE: 1,
    VISIBILITY_INTERNAL: 2,
    VISIBILITY_PUBLIC: 3,
    VISIBILITY_REDACTED: 4,
};
export const EmailProvider = {
    EMAIL_PROVIDER_INVALID: 'EMAIL_PROVIDER_INVALID',
    EMAIL_PROVIDER_GMAIL: 'EMAIL_PROVIDER_GMAIL',
    EMAIL_PROVIDER_OUTLOOK: 'EMAIL_PROVIDER_OUTLOOK',
};
export const EmailProviderValue = {
    EMAIL_PROVIDER_INVALID: 0,
    EMAIL_PROVIDER_GMAIL: 1,
    EMAIL_PROVIDER_OUTLOOK: 2,
};
export const SendStatus = {
    SEND_STATUS_INVALID: 'SEND_STATUS_INVALID',
    SEND_STATUS_PENDING: 'SEND_STATUS_PENDING',
    SEND_STATUS_SENDING: 'SEND_STATUS_SENDING',
    SEND_STATUS_SENT: 'SEND_STATUS_SENT',
    SEND_STATUS_DELIVERED: 'SEND_STATUS_DELIVERED',
    SEND_STATUS_FAILED: 'SEND_STATUS_FAILED',
    SEND_STATUS_DRAFT: 'SEND_STATUS_DRAFT',
};
export const SendStatusValue = {
    SEND_STATUS_INVALID: 0,
    SEND_STATUS_PENDING: 1,
    SEND_STATUS_SENDING: 2,
    SEND_STATUS_SENT: 3,
    SEND_STATUS_DELIVERED: 4,
    SEND_STATUS_FAILED: 5,
    SEND_STATUS_DRAFT: 6,
};
export const Direction = {
    DIRECTION_INVALID: 'DIRECTION_INVALID',
    DIRECTION_OUTBOUND: 'DIRECTION_OUTBOUND',
    DIRECTION_INBOUND: 'DIRECTION_INBOUND',
};
export const DirectionValue = {
    DIRECTION_INVALID: 0,
    DIRECTION_OUTBOUND: 1,
    DIRECTION_INBOUND: 2,
};
export const ParticipantType = {
    PARTICIPANT_TYPE_INVALID: 'PARTICIPANT_TYPE_INVALID',
    PARTICIPANT_TYPE_TO: 'PARTICIPANT_TYPE_TO',
    PARTICIPANT_TYPE_CC: 'PARTICIPANT_TYPE_CC',
    PARTICIPANT_TYPE_BCC: 'PARTICIPANT_TYPE_BCC',
    PARTICIPANT_TYPE_FROM: 'PARTICIPANT_TYPE_FROM',
};
export const ParticipantTypeValue = {
    PARTICIPANT_TYPE_INVALID: 0,
    PARTICIPANT_TYPE_TO: 1,
    PARTICIPANT_TYPE_CC: 2,
    PARTICIPANT_TYPE_BCC: 3,
    PARTICIPANT_TYPE_FROM: 4,
};
export const AIDraftBehavior = {
    AI_DRAFT_BEHAVIOR_INHERIT: 'AI_DRAFT_BEHAVIOR_INHERIT',
    AI_DRAFT_BEHAVIOR_DRAFT: 'AI_DRAFT_BEHAVIOR_DRAFT',
    AI_DRAFT_BEHAVIOR_SKIP: 'AI_DRAFT_BEHAVIOR_SKIP',
};
export const AIDraftBehaviorValue = {
    AI_DRAFT_BEHAVIOR_INHERIT: 0,
    AI_DRAFT_BEHAVIOR_DRAFT: 1,
    AI_DRAFT_BEHAVIOR_SKIP: 2,
};
export const TrackingMode = {
    TRACKING_MODE_INVALID: 'TRACKING_MODE_INVALID',
    TRACKING_MODE_CONTACTS_ONLY: 'TRACKING_MODE_CONTACTS_ONLY',
    TRACKING_MODE_ALL_SENDERS: 'TRACKING_MODE_ALL_SENDERS',
};
export const TrackingModeValue = {
    TRACKING_MODE_INVALID: 0,
    TRACKING_MODE_CONTACTS_ONLY: 1,
    TRACKING_MODE_ALL_SENDERS: 2,
};
export const SenderType = {
    SENDER_TYPE_INVALID: 'SENDER_TYPE_INVALID',
    SENDER_TYPE_PARTNER: 'SENDER_TYPE_PARTNER',
    SENDER_TYPE_BUSINESS: 'SENDER_TYPE_BUSINESS',
};
export const SenderTypeValue = {
    SENDER_TYPE_INVALID: 0,
    SENDER_TYPE_PARTNER: 1,
    SENDER_TYPE_BUSINESS: 2,
};
export const DomainType = {
    DOMAIN_TYPE_DEDICATED: 'DOMAIN_TYPE_DEDICATED',
    DOMAIN_TYPE_SHARED: 'DOMAIN_TYPE_SHARED',
};
export const DomainTypeValue = {
    DOMAIN_TYPE_DEDICATED: 0,
    DOMAIN_TYPE_SHARED: 1,
};
export const ChangeEmailDomainStatus = {
    CHANGE_EMAIL_DOMAIN_STATUS_INVALID: 'CHANGE_EMAIL_DOMAIN_STATUS_INVALID',
    CHANGE_EMAIL_DOMAIN_STATUS_ACCEPTED: 'CHANGE_EMAIL_DOMAIN_STATUS_ACCEPTED',
    CHANGE_EMAIL_DOMAIN_STATUS_PENDING: 'CHANGE_EMAIL_DOMAIN_STATUS_PENDING',
};
export const ChangeEmailDomainStatusValue = {
    CHANGE_EMAIL_DOMAIN_STATUS_INVALID: 0,
    CHANGE_EMAIL_DOMAIN_STATUS_ACCEPTED: 1,
    CHANGE_EMAIL_DOMAIN_STATUS_PENDING: 2,
};
export const Provider = {
    PROVIDER_INVALID: 'PROVIDER_INVALID',
    PROVIDER_GMAIL: 'PROVIDER_GMAIL',
    PROVIDER_OUTLOOK: 'PROVIDER_OUTLOOK',
};
export const ProviderValue = {
    PROVIDER_INVALID: 0,
    PROVIDER_GMAIL: 1,
    PROVIDER_OUTLOOK: 2,
};
export const EmailQueueStatus = {
    EMAIL_QUEUE_STATUS_UNSPECIFIED: 'EMAIL_QUEUE_STATUS_UNSPECIFIED',
    EMAIL_QUEUE_STATUS_RUNNING: 'EMAIL_QUEUE_STATUS_RUNNING',
    EMAIL_QUEUE_STATUS_DISABLED: 'EMAIL_QUEUE_STATUS_DISABLED',
};
export const EmailQueueStatusValue = {
    EMAIL_QUEUE_STATUS_UNSPECIFIED: 0,
    EMAIL_QUEUE_STATUS_RUNNING: 1,
    EMAIL_QUEUE_STATUS_DISABLED: 2,
};
export const Namespace = {
    NAMESPACE_INVALID: 'NAMESPACE_INVALID',
    NAMESPACE_EMAIL: 'NAMESPACE_EMAIL',
};
export const NamespaceValue = {
    NAMESPACE_INVALID: 0,
    NAMESPACE_EMAIL: 1,
};
export const BounceSenderType = {
    UNBOUNCE_SENDER_TYPE_INVALID: 'UNBOUNCE_SENDER_TYPE_INVALID',
    UNBOUNCE_SENDER_TYPE_PARTNER: 'UNBOUNCE_SENDER_TYPE_PARTNER',
    UNBOUNCE_SENDER_TYPE_BUSINESS: 'UNBOUNCE_SENDER_TYPE_BUSINESS',
    UNBOUNCE_SENDER_TYPE_YESWARE: 'UNBOUNCE_SENDER_TYPE_YESWARE',
};
export const BounceSenderTypeValue = {
    UNBOUNCE_SENDER_TYPE_INVALID: 0,
    UNBOUNCE_SENDER_TYPE_PARTNER: 1,
    UNBOUNCE_SENDER_TYPE_BUSINESS: 2,
    UNBOUNCE_SENDER_TYPE_YESWARE: 3,
};
export const RecipientStatusEnum = {
    RECIPIENT_STATUS_INVALID: 'RECIPIENT_STATUS_INVALID',
    RECIPIENT_STATUS_HARD: 'RECIPIENT_STATUS_HARD',
    RECIPIENT_STATUS_SOFT: 'RECIPIENT_STATUS_SOFT',
    RECIPIENT_STATUS_UNKNOWN: 'RECIPIENT_STATUS_UNKNOWN',
    RECIPIENT_STATUS_RESET: 'RECIPIENT_STATUS_RESET',
    RECIPIENT_STATUS_NOT_BLOCKED: 'RECIPIENT_STATUS_NOT_BLOCKED',
};
export const RecipientStatusEnumValue = {
    RECIPIENT_STATUS_INVALID: 0,
    RECIPIENT_STATUS_HARD: 1,
    RECIPIENT_STATUS_SOFT: 2,
    RECIPIENT_STATUS_UNKNOWN: 3,
    RECIPIENT_STATUS_RESET: 4,
    RECIPIENT_STATUS_NOT_BLOCKED: 5,
};
